import React from "react";
import { Button, Input, Row, Col } from "antd";
import styles from "../styles/Home.module.css";
import dark from "../styles/HomeDark.module.css";
import Navbar from "../Components/Global/Navbar";
import Hero from "../Components/Home/Hero";
import ImagesSlider from "../Components/Home/ImagesSlider";
import TheDao from "../Components/Home/TheDao";
import DOS from "../Components/Home/$DOS";
import News from "../Components/Home/News";


const Home = ({ theme, setTheme }) => {
  return (
    <>
      {" "}
      <Navbar theme={theme} setTheme={setTheme} />
      <div className={theme ? styles.container : dark.container}>
        <Hero theme={theme} setTheme={setTheme} />

        <ImagesSlider theme={theme} first={0} last={20} />

        <TheDao theme={theme} />

        <ImagesSlider theme={theme} first={21} last={42} />

        <DOS theme={theme} />
        <News theme={theme} />
      </div>
      <footer className={styles.footer}>
        <Row className={styles.mainRow}>
          <Row className={styles.innerRow}>
            <Col xs={24} sm={24} md={17}>
              {/* <Image src={logo} width={48} height={48} className={styles.logo} /> */}

              <span>Privacy Policy</span>
              <span className="ddd">Terms of Service</span>
              <span className={styles.copyRight}>
                ©Dospunks 2023, All Rights Reserved.
              </span>
            </Col>
            <Col xs={24} sm={16} md={4}>
              <h6>Genesis Collections</h6>
              <p>DOSPUNKS</p>
              <p>DOSPUNKS (TEZ)</p>
              <p>DOS TRASHBIRDS</p>
              <p>DOSAMIGOS</p>
            </Col>
            <Col xs={24} sm={8} md={3}>
              <h6>Connect</h6>
              <p>Twitter</p>
              <p>TELGRAM</p>
              <p>Discord</p>
              <p>Opensea</p>
            </Col>
          </Row>
        </Row>
      </footer>
    </>
  );
};

export default Home;
